import { CUSTOM_CATEGORIES } from 'utils/constants/casino/custom-categories';

export const checkIsSelectedCategoryFavorites = (
  selectedCategory: string
): boolean => {
  return selectedCategory === CUSTOM_CATEGORIES.favorite.id;
};
